<template>
    <div id="app">

        <div class="mb-5">
            <Breadcrumb></Breadcrumb>
        </div>

        <router-view/>

        <Lightbox v-if="lightboxVisible"></Lightbox>
    </div>
</template>


<style lang="scss" scoped>

</style>

<script>
    import Breadcrumb from "./components/Breadcrumb";
    import Sidebar from "./Sidebar";
    import Lightbox from "./components/Lightbox";

    export default {
        components: {Lightbox, Breadcrumb},
        computed: {
            lightboxVisible() {
                return this.$store.state.lightboxVisible
            },

        }
    }
</script>